import Layout from "../../Internal/Layout.vue";
import ProductsPage from "./Products.vue";
import ProductsAdd from "./ProductsAdd/ProductsAdd";
import ProductsConfig from "./ProductsConfig/ProductsConfig";
import CouponsPage from "./Coupons/Coupons";
import AddCouponsPage from "./Coupons/AddCoupon";
import ProductsSortCategory from "./ProductsConfig/components/ProductsSortCategory";
import ProductsSortSubCategory from "./ProductsConfig/components/ProductsSortSubCategory";

const ProductRoutes = {
  component: Layout,
  children: [
    {
      path: "/",
      name: "Products",
      component: ProductsPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
    {
      path: "/add-product",
      name: "ProductsAdd",
      component: ProductsAdd,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
      props: { resales: true },
    },
    {
      path: "/products-config",
      name: "ProductsConfig",
      component: ProductsConfig,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
      props: { resales: true },
    },
    {
      path: "/coupons",
      name: "CouponsPage",
      component: CouponsPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
    {
      path: "/add-coupons",
      name: "AddCouponsPage",
      component: AddCouponsPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
    {
      path: "/ordem-visualizacao-categoria",
      name: "ProductsSortCategory",
      component: ProductsSortCategory,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
    {
      path: "/ordem-visualizacao-subcategoria",
      name: "ProductsSortSubCategory",
      component: ProductsSortSubCategory,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
      },
    },
  ],
};

export default ProductRoutes;
